<div class="notification">
    <h3>Unread Messages: {{ unreadMessageCount }}</h3>
    <h3>Friends count{{friendsCount}}</h3>
  </div>
  